import counterUp from 'counterup2'

window.counterUp = counterUp
